// TODO testen
// TODO warnung für nicht unterstütze sachen (bzw implementieren)

import AnimationProcess, { AnimationData } from "engine/Utils/AnimationProcess";
import * as PIXI from "pixi.js";
import { BaseTexture } from "@pixi/core";

export class PyxelFile<AnimationNames extends string = string> {
	
	private readonly name: string;
	private readonly image: string;
	private readonly textures: PIXI.Spritesheet['textures'];
	// expose baseTexture for HMR
	public readonly baseTexture: BaseTexture;
	
	public readonly width: number;
	public readonly height: number;
	public readonly tileWidth: number;
	public readonly tileHeight: number;
	
	private animations: { data: PIXI.FrameObject[], timeMultiplyer: number }[];
	private animationNames: Map<AnimationNames, number> = new Map();
	
	constructor(sheet: PIXI.Spritesheet) {
		let data = (sheet.data.meta as any).pyxel;
		
		this.name = data.name;
		this.image = (sheet.data.meta as any).image;
		this.textures = sheet.textures;
		this.baseTexture = sheet.baseTexture;
		
		this.width = data.canvas.width;
		this.height = data.canvas.height;
		this.tileWidth = data.canvas.tileWidth;
		this.tileHeight = data.canvas.tileHeight;
		
		this.animations = [];
		
		this.init(data);
		
	}
	
	private init(data) {
		let animationData;
		for(let id = 0; animationData = data.animations[id]; id++) {
	//	for(let animationData of Object.values(data.animations)) {
			if(this.animationNames.has(animationData.name)) {
				console.warn(`Some Animations in '${this.name}.pyxel' are using the same Name.`);
			} else {
				this.animationNames.set(animationData.name, id);// this.animations.length);
			}
			
			let data: PIXI.FrameObject[] = [];

			for(let i = 0; i < animationData.length; i++) {
				data.push({
					texture: this.textures[this.image + (animationData.baseTile + i)],
					time: animationData.frameDurationMultipliers[i],
				});
			}
			
			this.animations.push({ data, timeMultiplyer: animationData.frameDuration / 100 });
		}
	}
	
	public getTile(x: number, y: number): PIXI.Texture {
		let tx = Math.ceil(this.width / this.tileWidth);
		let ty = Math.ceil(this.height / this.tileHeight);
		
		if(x >= tx || y >= ty) {
			throw new Error(`Tile (${x}, ${y}) not in '${this.name}.pyxel'.`);
		}
		
		return this.textures[this.image + (x + y * tx)];
	}
	
	public getAnimationById(id: number): AnimationData {
		if(id >= this.animations.length) {
			throw new Error(`Animation if id '${id}' is not defined in '${this.name}.pyxel'.`);
		}
		let { data, timeMultiplyer } = this.animations[id];
		
		return {
			textures: data,
			animationSpeed: 1 / timeMultiplyer,
		};
	}
	
	public getAnimation(name: AnimationNames): AnimationData {
		let id = this.animationNames.get(name);
		
		if(id === undefined) {
			throw new Error(`Animation '${name}' is not defined in '${this.name}.pyxel'.`);
		}
		
		return this.getAnimationById(id);
	}
	
}
